export default {
    "AX" : "Aaland Islands",
    "AF" : "Afghanistan",
    "AL" : "Albania",
    "DZ" : "Algeria",
    "AS" : "American Samoa",
    "AD" : "Andorra",
    "AO" : "Angola",
    "AI" : "Anguilla",
    "AQ" : "Antarctica",
    "AG" : "Antigua and Barbuda",
    "AR" : "Argentina",
    "AM" : "Armenia",
    "AW" : "Aruba",
    "AU" : "Australia",
    "AT" : "Austria",
    "AZ" : "Azerbaijan",
    "BS" : "Bahamas",
    "BH" : "Bahrain",
    "BD" : "Bangladesh",
    "BB" : "Barbados",
    "BY" : "Belarus",
    "BE" : "Belgium",
    "BZ" : "Belize",
    "BJ" : "Benin",
    "BM" : "Bermuda",
    "BT" : "Bhutan",
    "BO" : "Bolivia",
    "BQ" : "Bonaire, Sint Eustatius And Saba",
    "BA" : "Bosnia-Herzegovina",
    "BW" : "Botswana",
    "BV" : "Bouvet Island",
    "BR" : "Brazil",
    "IO" : "British Indian Ocean Territory",
    "BN" : "Brunei",
    "BG" : "Bulgaria",
    "BF" : "Burkina Faso",
    "BI" : "Burundi",
    "KH" : "Cambodia",
    "CM" : "Cameroon",
    "CA" : "Canada",
    "CV" : "Cape Verde",
    "KY" : "Cayman Islands",
    "CF" : "Centrafricana Republique",
    "TD" : "Chad",
    "CL" : "Chile",
    "CN" : "China",
    "CX" : "Christmas Island",
    "CC" : "Cocos Islands",
    "CO" : "Colombia",
    "KM" : "Comoros",
    "CG" : "Congo Rep. Democratique",
    "CD" : "Congo, The Democratic Republic Of The",
    "CK" : "Cook Islands",
    "CR" : "Costa Rica",
    "CI" : "Côte d’Ivoire",
    "HR" : "Croatia",
    "CU" : "Cuba",
    "CW" : "Curacao",
    "CY" : "Cyprus",
    "CZ" : "Czechia",
    "DK" : "Denmark",
    "DJ" : "Djibouti",
    "DM" : "Dominica",
    "DO" : "Dominican Republic",
    "EC" : "Ecuador",
    "EG" : "Egypt",
    "SV" : "El Salvador",
    "GQ" : "Equatorial Guinea",
    "ER" : "Eritrea",
    "EE" : "Estonia",
    "ET" : "Ethiopia",
    "FK" : "Falkland Islands",
    "FO" : "Faroe Islands",
    "FJ" : "Fiji",
    "FI" : "Finland",
    "FR" : "France",
    "GF" : "French Guiana",
    "PF" : "French Polynesia",
    "TF" : "French Southern Territories",
    "GA" : "Gabon Republique",
    "GM" : "Gambia Republic",
    "GE" : "Georgia",
    "DE" : "Germany",
    "GH" : "Ghana Republic",
    "GI" : "Gibraltar",
    "GR" : "Greece",
    "GL" : "Greenland",
    "GD" : "Grenada",
    "GP" : "Guadeloupe",
    "GU" : "Guam",
    "GT" : "Guatemala",
    "GG" : "Guernsey",
    "GN" : "Guinee Republique",
    "GW" : "Guinea-Bissau Republica",
    "GY" : "Guyana",
    "HT" : "Haiti",
    "HM" : "Heard And Mc Donald Islands",
    "VA" : "Holy See (Vatican City State)",
    "HN" : "Honduras",
    "HK" : "Hong Kong",
    "HU" : "Hungary",
    "IS" : "Iceland",
    "IN" : "India",
    "ID" : "Indonesia",
    "IR" : "Iran",
    "IQ" : "Iraq",
    "IE" : "Ireland",
    "IM" : "Isle Of Man",
    "IL" : "Israel",
    "IT" : "Italy",
    "JM" : "Jamaica",
    "JP" : "Japan",
    "JE" : "Jersey",
    "JO" : "Jordan",
    "KZ" : "Kazakhstan",
    "KE" : "Kenya",
    "KI" : "Kiribati",
    "KP" : "North Korea",
    "KR" : "South Korea",
    "KW" : "Kuwait",
    "KG" : "Kyrgyzstan",
    "LA" : "Laos",
    "LV" : "Latvia",
    "LB" : "Lebanon",
    "LS" : "Lesotho Kingdom",
    "LR" : "Liberia Republic",
    "LY" : "Libya",
    "LI" : "Liechtenstein",
    "LT" : "Lithuania",
    "LU" : "Luxembourg",
    "MO" : "Macau",
    "MK" : "Macedonia",
    "MG" : "Madagascar Republique",
    "MW" : "Malawi Republic",
    "MY" : "Malaysia",
    "MV" : "Maldives",
    "ML" : "Republic of Maldives",
    "MT" : "Malta",
    "MH" : "Marshall Islands",
    "MQ" : "Martinique",
    "MR" : "Mauritania",
    "MU" : "Mauritius Ile Republic",
    "YT" : "Mayotte",
    "MX" : "Mexico",
    "FM" : "Federated States of Micronesia",
    "MD" : "Moldova",
    "MC" : "Monaco Principaute",
    "MN" : "Mongolia",
    "ME" : "Montenegro",
    "MS" : "Montserrat",
    "MA" : "Morocco",
    "MZ" : "Mocambique Republique",
    "MM" : "Myanmar",
    "NA" : "Namibia Republic",
    "NR" : "Nauru",
    "NP" : "Nepal",
    "NL" : "Netherlands",
    "NC" : "New Caledonia",
    "NZ" : "New Zealand",
    "NI" : "Nicaragua",
    "NE" : "Niger Republique",
    "NG" : "Nigeria Republic",
    "NU" : "Niue",
    "NF" : "Norfolk Island",
    "MP" : "Northern Mariana Islands",
    "NO" : "Norway",
    "OM" : "Oman",
    "PK" : "Pakistan",
    "PW" : "Palau",
    "PS" : "Palestinian Territory, Occupied",
    "PA" : "Panama",
    "PG" : "Papua New Guinea",
    "PY" : "Paraguay",
    "PE" : "Peru",
    "PH" : "Philippines",
    "PN" : "Pitcairn",
    "PL" : "Poland",
    "PT" : "Portugal",
    "PR" : "Puerto Rico",
    "QA" : "Qatar",
    "RE" : "Ile de la Reunion",
    "RO" : "Romania",
    "RU" : "Russia",
    "RW" : "Rwanda",
    "SH" : "St. Helena",
    "BL" : "Saint Barthélemy",
    "KN" : "St. Kitts/Nevis",
    "LC" : "St. Lucia",
    "PM" : "St. Pierre et Miquelon",
    "VC" : "St. Vincent",
    "WS" : "Samoa",
    "SM" : "San Marino",
    "ST" : "Sao Tome e Principe",
    "SA" : "Saudi Arabia",
    "SN" : "Senegal Republique",
    "RS" : "Serbia",
    "SC" : "Seychelles Republique",
    "SL" : "Sierra Leone Republic",
    "SG" : "Singapore",
    "SX" : "Sint Maarten (Dutch Part)",
    "SK" : "Slovakia",
    "SI" : "Slovenia",
    "SB" : "Solomon Islands",
    "SO" : "Somalia",
    "ZA" : "South Africa",
    "GS" : "South Georgia And The South Sandwich Islands",
    "SS" : "South Sudan",
    "ES" : "Spain",
    "LK" : "Sri Lanka",
    "SD" : "Sudan",
    "SR" : "Surinam",
    "SJ" : "Svalbard And Jan Mayen Islands",
    "SZ" : "Swaziland Kingdom",
    "SE" : "Sweden",
    "CH" : "Switzerland",
    "SY" : "Syria Republic",
    "TW" : "Taiwan",
    "TJ" : "Tajikistan",
    "TZ" : "Tanzania",
    "TH" : "Thailand",
    "TL" : "Timor-Leste",
    "TG" : "Togolaise Republique",
    "TK" : "Tokelau",
    "TO" : "Tonga",
    "TT" : "Trinidad and Tobago",
    "TN" : "Tunisia",
    "TR" : "Turkey",
    "TM" : "Turkmenistan",
    "TC" : "Turks & Caicos Isles",
    "TV" : "Tuvalu",
    "UG" : "Uganda Republic",
    "UA" : "Ukraine",
    "AE" : "United Arab Emirates",
    "GB" : "United Kingdom",
    "US" : "USA",
    "UM" : "United States Minor Outlying Islands",
    "UY" : "Uruguay",
    "UZ" : "Uzbekistan",
    "VU" : "Vanuatu",
    "VE" : "Venezuela",
    "VN" : "Vietnam",
    "VG" : "British Virgin Islands",
    "VI" : "Virgin Islands (U.S.)",
    "WF" : "Wallis e Futuna",
    "EH" : "Western Sahara",
    "YE" : "Yemen",
    "ZM" : "Zambia Republic",
    "ZW" : "Zimbabwe Republic"
}